import { Logo } from "@/components/Logo";
import { BrandPanel } from "@/pages/AuthPage";
import { LegalFooter } from "@/components/LegalFooter";

export const AuthShell = ({ title, subtitle, children }) => (
  <div className="min-h-screen grid lg:grid-cols-2 bg-white">
    <BrandPanel />
    <div className="flex flex-col justify-center px-6 sm:px-12 py-12">
      <div className="w-full max-w-md mx-auto mt-fade-up">
        <div className="lg:hidden mb-10">
          <Logo />
        </div>
        <h1 className="font-heading text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900">{title}</h1>
        {subtitle && <p className="text-slate-500 mt-2">{subtitle}</p>}
        {children}
        <LegalFooter className="mt-12" />
      </div>
    </div>
  </div>
);
